import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    height: "100vh",

    overflow: "auto",
    overflowX: "hidden",
    fontFamily: "Roboto",
    "@media all and (max-width: 900px)": {
      height: "100vh",
      marginTop: 80,
    },
  },
  boxTable: {
    width: "90%",
    marginLeft: "5%",
    background: "#f9f9f9",
    boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.2)",
    borderRadius: 10,
    marginTop: "1rem",
    maxHeight: "900px",
    overflowY: "visible",
  },
  boxtitle: {
    width: "90%",
    display: "flex",
    marginLeft: "5%",
    color: "#4B4952",
    paddingTop: "1rem",
  },
  title: {
    fontSize: "2em",
    letterSpacing: "0.04rem",
    "@media all and (max-width: 600px)": {
      fontSize: "1.5em",
    },
  },
  boxTableArca: {
    width: "90%",
    marginLeft: "5%",
    background: "#f9f9f9",
    boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.2)",
    borderRadius: 10,
    marginTop: "1rem",
    display: "flex",
    flexDirection: "row",
  },
  boxSearchBarAlta: {
    width: "95%",
    display: "flex",
    marginBottom: "0.5%",
    marginLeft: "0.5%",
    alignItems: "center",
    gap: "20px",
    justifyContent: "flex-start",
  },
  boxSubTitle: {
    width: "90%",
    display: "flex",
    alignItems: "center",
    color: "#4B4952",
    background: "#f9f9f9",
    boxShadow: "0px 1px 4px rgba(36, 55, 143, 0.2)",
    borderRadius: 10,
    paddingBottom: 10,
    paddingTop: 10,
    marginLeft: "5%",
    marginTop: "1rem",
    "@media all and (max-width: 600px)": {
      fontSize: "0.8em",
    },
  },
  subtitle: {
    fontSize: "1rem",
    marginLeft: 8,
    fontWeight: "bold",
    "@media all and (max-width: 600px)": {
      fontSize: "1em",
    },
  },
  boxSearchBar: {
    width: "95%",
    display: "flex",
    padding: "5px 10px",
    alignItems: "center",
  },
  containerSearchValueButton: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  buttonResetFilterCUIT: {
    height: "30px",
    width: "150px",
    padding: "5px",
    margin: "5px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f2f2f2",
    cursor: "pointer",
    border: "2px solid #028B7E",
    borderRadius: "23px",
    "&:hover": {
      backgroundColor: "#fff",
      border: "3px solid #028B7E",
    },
    "@media all and (max-width: 600px)": {
      height: "28px",
      width: "110px",
    },
  },
  pagination: {
    marginTop: 1,
    marginBottom: 2,
    display: "flex",
    justifyContent: "center",
    color: "#028B7E",
    "@media all and (max-width: 1200px)": {
      marginTop: 0,
      marginBottom: "2%",
    },
  },
  buttonResetFilterClientName: {
    height: "30px",
    padding: "5px 10px",
    margin: "5px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f2f2f2",
    cursor: "pointer",
    border: "2px solid #028B7E",
    borderRadius: "23px",
    "&:hover": {
      backgroundColor: "#fff",
      border: "3px solid #028B7E",
    },
  },
  closeIconButtonReset: {
    fontSize: "16px",
    color: "#028B7E",
    "@media all and (max-width: 600px)": {
      fontSize: "11px",
    },
  },
  typographyButton: {
    fontFamily: "Raleway",
    fontSize: "14px",
    letterSpacing: "0.05em",
    color: "#028B7E",
    "@media all and (max-width: 600px)": {
      fontSize: "11px",
    },
  },
  buttonsearch: {
    marginTop: "10px",
    height: "32px",
    width: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f2f2f2",
    cursor: "pointer",
    color: "#028B7E",
    border: "2px solid #028B7E",
    borderRadius: "23px",
    fontWeight: "bold",
    fontFamily: "Roboto",
    "&:hover": {
      backgroundColor: "#fff",
    },
    "@media all and (max-width: 600px)": {
      height: "28px",
      width: "135px",
    },
  },
  loadMoreIndicator: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    backgroundColor: "#f9f9f9",
    borderRadius: 8,
    margin: "16px 0",
  },

  loadMoreButton: {
    display: "flex",
    justifyContent: "center",
    padding: "20px 0",
  },

  loadMoreBtn: {
    padding: "12px 24px",
    backgroundColor: "#00a78f",
    color: "white",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#008a7a",
    },
    "&:disabled": {
      backgroundColor: "#cccccc",
      cursor: "not-allowed",
    },
  },

  endMessage: {
    textAlign: "center",
    padding: 20,
    color: "#666",
    borderTop: "1px solid #e0e0e0",
    marginTop: 16,
  },

  resultsInfo: {
    textAlign: "center",
    padding: 16,
    color: "#666",
    fontSize: 14,
    borderTop: "1px solid #e0e0e0",
    backgroundColor: "#f9f9f9",
  },

  scrollIndicator: {
    position: "fixed",
    bottom: 20,
    right: 20,
    background: "rgba(0, 167, 143, 0.9)",
    color: "white",
    padding: "8px 12px",
    borderRadius: 20,
    fontSize: 12,
    zIndex: 1000,
    transition: "opacity 0.3s ease",
    "&.hidden": {
      opacity: 0,
      pointerEvents: "none",
    },
  },

  fadeInRow: {
    animation: "$fadeIn 0.3s ease-in-out",
  },

  "@keyframes fadeIn": {
    from: {
      opacity: 0,
      transform: "translateY(10px)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
}))

export default useStyles
